import { render, staticRenderFns } from "./AdminHistoryCreate.vue?vue&type=template&id=6ff9f57d&"
import script from "./AdminHistoryCreate.vue?vue&type=script&lang=js&"
export * from "./AdminHistoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports